// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* JobRoleList Component Styles */

.scl--web-component-job-role-list-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 31px;
  width: 100%;
}

/* Bordered variant container */
.scl--web-component-job-role-list-container:has(.scl--web-component-job-role-item--bordered) {
  gap: 30px;
}

/* Job Role Item */
.scl--web-component-job-role-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 47px;
  position: relative;
  cursor: pointer;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
  transition: all 0.5s;
}

/* Job Role Content - wrapper for title and location */
.scl--web-component-job-role-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  opacity: 1;
}

/* Bordered variant - wraps item in column with border */
.scl--web-component-job-role-item--bordered {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  height: 38px;
}

.scl--web-component-job-role-item--bordered::after {
  content: '';
  width: 100%;
  height: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  order: 1;
  flex: none;
  align-self: stretch;
}

/* Hover effect */


/* Job Role Title */
.scl--web-component-job-role-title {
  width: calc(100% - 150px);
  height: auto;
  font-family: var(--primary-font);
  font-style:  normal;
  font-weight: 400;
  font-size:  22px;
  line-height: 30px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color:  #FFFFFF;
}

.scl--web-component-job-role-item:hover .scl--web-component-job-role-title {
  text-decoration-line: underline;
  text-decoration-thickness: 1px;     
  text-underline-offset: 4px;
}

/* Bordered variant title - smaller font */
.scl--web-component-job-role-item--bordered .scl--web-component-job-role-title {
  font-size: 18px;
}

/* Location Wrapper */
.scl--web-component-job-role-location-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 5px;
  width: auto;
  height: 30px;
}

/* Job Role Location */
.scl--web-component-job-role-location {
  width: auto;
  height: 30px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 30px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: #7D8187;
  flex: none;
  order: 0;
  flex-grow: 0;
}
`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/list/job-role/css/jobRoleList.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,iDAAiD;EACjD,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA,iBAAiB;;;AAGjB,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd","sourcesContent":["/* JobRoleList Component Styles */\n\n.scl--web-component-job-role-list-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 31px;\n  width: 100%;\n}\n\n/* Bordered variant container */\n.scl--web-component-job-role-list-container:has(.scl--web-component-job-role-item--bordered) {\n  gap: 30px;\n}\n\n/* Job Role Item */\n.scl--web-component-job-role-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 47px;\n  position: relative;\n  cursor: pointer;\n  flex: none;\n  align-self: stretch;\n  flex-grow: 0;\n  transition: all 0.5s;\n}\n\n/* Job Role Content - wrapper for title and location */\n.scl--web-component-job-role-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n}\n\n/* Bordered variant - wraps item in column with border */\n.scl--web-component-job-role-item--bordered {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 8px;\n  height: 38px;\n}\n\n.scl--web-component-job-role-item--bordered::after {\n  content: '';\n  width: 100%;\n  height: 0px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  order: 1;\n  flex: none;\n  align-self: stretch;\n}\n\n/* Hover effect */\n\n\n/* Job Role Title */\n.scl--web-component-job-role-title {\n  width: calc(100% - 150px);\n  height: auto;\n  font-family: var(--primary-font);\n  font-style:  normal;\n  font-weight: 400;\n  font-size:  22px;\n  line-height: 30px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.01em;\n  color:  #FFFFFF;\n}\n\n.scl--web-component-job-role-item:hover .scl--web-component-job-role-title {\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;     \n  text-underline-offset: 4px;\n}\n\n/* Bordered variant title - smaller font */\n.scl--web-component-job-role-item--bordered .scl--web-component-job-role-title {\n  font-size: 18px;\n}\n\n/* Location Wrapper */\n.scl--web-component-job-role-location-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n  gap: 5px;\n  width: auto;\n  height: 30px;\n}\n\n/* Job Role Location */\n.scl--web-component-job-role-location {\n  width: auto;\n  height: 30px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 30px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.01em;\n  color: #7D8187;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
